import {UrlSource} from 'mediabunny';
import {createMaskVideoReader} from './cinematic-mask-frame';
/** The React19 company package owns its newer decoder's request-parallelism option. */
export function createCompanyMaskVideoReader(src:string){
  return createMaskVideoReader(src,url=>new UrlSource(url,{requestInit:{cache:'reload',credentials:'omit'},getRetryDelay:()=>null,parallelism:1,maxCacheSize:32*1024*1024}));
}
